import React from 'react';
import { Box, SpaceBetween } from '@amzn/awsui-components-core';

const LIVE_DOT_STYLE: React.CSSProperties = {
  display: 'inline-block',
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: '#1db954',
  boxShadow: '0 0 4px 2px rgba(29, 185, 84, 0.5)'
};

const DOT_WRAPPER_STYLE: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 16,
  height: 16
};

interface LiveStatusIndicatorProps {
  label?: string;
  bold?: boolean;
}

export const LiveStatusIndicator: React.FC<LiveStatusIndicatorProps> = ({ label = 'Live', bold = false }) => (
  <SpaceBetween size="s" direction="horizontal" alignItems="center">
    <span style={DOT_WRAPPER_STYLE}>
      <span style={LIVE_DOT_STYLE} data-testid="live-status-dot" />
    </span>
    <Box color="text-status-success" fontWeight={bold ? 'bold' : 'normal'}>{label}</Box>
  </SpaceBetween>
);
